import { validator } from "@/utils/validator";

export const verifyLoginSchema = validator.object().shape({
  email: validator.string().emptyToNull().autoTransformToHalfWidth().label("メールアドレス"),
  code: validator.string().emptyToNull().autoTransformToHalfWidth().label("認証コード").required(),
});
